/* @jsxRuntime automatic */
/* @jsxImportSource @superweb/css */

import { cssFns } from "@superweb/css";

import { useUiColors } from "../theme";
import { useTypo } from "../typo";
import { Message } from "#intl";
import { VisuallyHidden } from "react-aria";

/**
 * Component for display count of char for input field.
 * @internal
 * Used in components of various input fields.
 */
export const FieldCharacterCounter = ({
  maxLength,
  length,
  id,
}: {
  /**
   * Input max length.
   */
  maxLength?: number;

  /**
   * Input current length.
   */
  length: number;

  /**
   * ID of the component.
   * Used to communicate with the input field.
   */
  id: string;
}) => {
  const typo = useTypo();
  const uiColors = useUiColors();

  return (
    <>
      <div
        css={{
          ...cssFns.padding("0", "16px"),
          ...cssFns.margin("0", "auto"),
          marginInlineEnd: "0",
          paddingBlockStart: "4px",
          ...typo({
            level: "caption1",
            density: "tight",
            weight: "regular",
          }),
          color: uiColors.textMinor,
        }}
      >
        {length}/{maxLength}
      </div>
      <VisuallyHidden id={id}>
        <Message
          id="52779f3b-2011-4aac-838d-b4016eef3e9b"
          context="Character counter title. For screen readers, not visible"
          default="{length} of {maxLength} characters used"
          values={{
            length,
            maxLength,
          }}
        />
      </VisuallyHidden>
    </>
  );
};
